import { SearchBy } from "../Enum/Enum";

export class VoyageDetailsModel {
    searchDate: string;
    fromPortId: number;
    toPortId: number;
    searchBy: SearchBy;
    pageNo: number;
    recPerPage: number;
    ShippingLineIds: string;
    toPortArrivalDate: string;
    fromPortArrivalDate: string;
    vesselsId: number;    
    userDetailsId: number;
    isBasicSearch: string;
    toVesselsId: number;
    midPortId: number;
    cubicMeter:number;
    transhipment:number;
    fromShippingLineId:number;
    toShippingLineId:number;
    findToDate:boolean=false;
}